
const editorHeight = '420px';

export const getStyles = (_, { palette = {} }) => ({
  bingMapsLocationTargetsEditor: {
    '& .bing-maps-location-targets-search-box-with-search-options': {
      maxWidth: '600px',
      marginBottom: '32px',

      '& .bing-maps-location-targets-search-type-choice-group': {
        marginBottom: '7px',

        '& .ms-ChoiceField label': {
          fontWeight: 'normal',
          padding: 0,
          marginLeft: '7px',
        },
      },

      '& .bing-maps-location-targets-search-prompt': {
        fontSize: '12px',
        lineHeight: '16px',
        color: '#605e5c',
        marginTop: '8px',
      },

      '& .bing-maps-search-box-results-menu': {
        zIndex: 200, // display search results above Bing Maps view
      },

    },

    '& .bing-maps-location-targets-search-grid-and-map, .bing-maps-location-target-and-map': {
      width: '900px',
      border: `1px solid ${palette.neutralSecondary}`,
      padding: '16px',
      display: 'flex',
    },

    '& .bing-maps-location-targets-search-grid': {
      maxHeight: editorHeight,
      width: '400px',
      display: 'flex',
      flexDirection: 'column',

      '& .search-box-header': {
        lineHeight: '19px',
        fontWeight: 'bold',
        marginBottom: '7px',
      },

      '& .search-box': {
        marginBottom: '16px',
      },

      '& .search-box-footer': {
        lineHeight: '20px',
        color: palette.neutralSecondary,
        marginTop: '8px',
        marginBottom: '16px',
      },
      '& .radius-slider': {
        marginTop: '16px',
      },

      // grid of location targets should fit vertically inside the editor and scroll when overflowed
      '& .bing-maps-location-targets-grid, & .bing-maps-negative-location-targets-grid': {
        flexGrow: 1,
        overflowY: 'auto',
        marginTop: '16px',
        minHeight: '150px',
      },

      '& .location-targets-grid-header': {
        padding: '0 0 12px 12px',

        '& h3': {
          fontSize: '14px',
          lineHeight: '19px',
          fontWeight: 'normal',
          margin: 0,
          padding: 0,
        },

        '& button.remove-all-location-targets': {
          height: 'auto',
          padding: 0,
          border: 0,

          fontSize: '14px',
          lineHeight: '19px',
        },
      },

      '& .location-targets-grid-error': {
        color: '#a80000',
        fontSize: '12px',
        lineHeight: '16px',
        display: 'flex',
        marginBottom: '18px',
        marginLeft: '12px',

        '& .location-targets-grid-error-message': {
          marginLeft: '4px',
        },
      },

      '& .location-targets-grid-details-list': {
        borderTop: '1px solid #edebe9',
      },

      '& .bing-maps-location-targets-empty': {
        marginTop: '16px',
      },
    },

    '& .bing-maps-location-targets-editor-map': {
      height: editorHeight,
      width: '450px',
      marginLeft: '32px',

      background: '#ACC7F2',
      textAlign: 'center',

      '& .bing-maps-location-target-map-tooltip': {
        textAlign: 'initial',
        paddingBottom: '26px',

        '& .tooltip-container': {
          padding: 15,
          boxShadow: '0 3.2px 7.2px 0 rgba(0,0,0,.132), 0 0.6px 1.8px 0 rgba(0,0,0,.108)',
          backgroundColor: 'rgba(255, 255, 255, 0.95)',
          '@supports (backdrop-filter: blur(60px))': {
            backdropFilter: 'blur(60px)',
            backgroundColor: 'rgba(255, 255, 255, 0.25)',
          },

          marginLeft: '-26px',
          width: '256px',
        },


        '& .title': {
          fontSize: '14px',
          margin: '0 4px 0 0',
          overflow: 'hidden',
        },
      },
    },

    '& .bing-maps-location-targets-editor-map-and-zoom-buttons': {
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',

      '& .zoom-buttons': {
        height: 'auto',
        padding: '0px',
        marginTop: '2px',
        right: '0px',
        textAlign: 'right',
        '& .ms-Button-label': {
          margin: 0,
          padding: '0px',
        },
      },

      '& .error': {
        marginLeft: '32px',
      },
    },

    '& .location-target-grid-row-button': {
      height: 'auto',
    },
  },

  locationTargetEditCallout: {
    padding: '16px',
    width: '360px',

    '& .ms-ChoiceField-wrapper::after': {
      border: 0,
    },

    '& .ms-Button:focus::after': {
      outline: 'none',
    },

    '& .location-choice-group': {
      marginBottom: '18px',

      '& label': {
        fontWeight: 'normal',
        fontSize: '14px',
        lineHeight: '19px',
        padding: 0,
      },
    },

    '& .radius-location-choice': {
      display: 'flex',
      alignItems: 'baseline',

      '& .radius-location-size-input': {
        marginLeft: '12px',
        marginRight: '12px',
        width: '100px',

        '& .ms-TextField-errorMessage': {
          display: 'none',
        },
      },

      '& .radius-unit-dropdown': { marginTop: '1px', width: '120px' },
    },

    '& .boundary-location-choice-disabled': {
      fontSize: '12px',
      color: '#a80000',
      lineHeight: '16px',
      marginTop: '7px',
      marginLeft: '26px',
    },

    '& .location-callout-buttons': {
      marginTop: '22px',

      '& button': { marginRight: '8px' },
    },
  },
});
